exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/annotation-detail/annotation-detail.component.scss
// module id = ../../../../../src/app/components/annotation-detail/annotation-detail.component.scss
// module chunks = main